<template>
  <div>
    <my-tab :tab="tab" :active="active" @tab="reTab"></my-tab>
    <ly-time @timeObj="reTimeObj"></ly-time>
    <div id="mylist" style="top: 140px">
      <div id="aedser" v-show="now == 1"></div>
      <Table v-show="now == 2" :columns="columns" :data="tableData" :height=height></Table>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import axios from "axios";
export default {
  data() {
    return {
      tab: [
        { title: "图表", mark: 1 },
        { title: "表格", mark: 2 },
      ],
      active: 0,
      now: 1,
      columns: [
        {
          title: "车牌号",
          key: "carNo",
        },
        {
          title: "里程",
          key: "mileage",
        },
      ],
      tableData: [],
      deviceIdList: [],
      timeObj: {},
      pageSize: 100,
      pageNumber: 1,
      picX: [],
      picY: [],
      height:100
    };
  },
  methods: {
    getData() {
      let params = {
        deviceIdList: this.deviceIdList,
        endTime: this.timeObj.end,
        startTime: this.timeObj.start,
        //pageSize: this.pageSize,
        //pageNumber: this.pageNumber,
      };
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.report + "/countMonth/list",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList.filter(function (item) {
          return item.mileage > 0;
        });
        data = data.sort(function up(x, y) {
          return y.mileage - x.mileage;
        });
        this.picX = [];
        this.picY = [];
        for (const i in data) {
          this.picX.push(data[i].carNo);
          this.picY.push(data[i].mileage);
        }
        this.tableData = data;
        this.drawBar();
      });
    },
    drawBar() {
      var that = this;
      this.chart = echarts.init(document.getElementById("aedser"));
      this.option = {
        backgroundColor: "",
        tooltip: {
          trigger: "axis",
          formatter: function (val) {
            var dd = val[0];
            return dd.name + "：" + dd.data + "km";
          },
        },
        legend: {
          show: false,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: 0,
          containLabel: true,
        },
        xAxis: {
          type: "value",
          inverse:false
        },
        yAxis: {
          type: "category",
          data: this.picX,
          inverse:true
        },
        dataZoom: [
          {
            type: "inside",
            //type: "slider",
            yAxisIndex: [0],
            //xAxisIndex:[0],
            start: 0, //放大起点
            //end: this.end(list),
            end: 100, //放大终点
            //startValue:10,
            //zoomLock:true
          },
        ],
        series: [
          {
            name: "Direct",
            type: "bar",
            stack: "total",
            label: {
              show: false,
              //position:"right"
            },
            emphasis: {
              focus: "series",
            },
            data: this.picY,
          },
        ],
        color: ["#e02626"],
      };
      this.chart.setOption(this.option);

      this.chart.resize();
    },
    reTab(v) {
      this.now = v.mark;
      if (this.now == 1) {
        setTimeout(() => {
          this.drawBar();
        }, 500);
      }
    },
    reTimeObj(v) {
      this.timeObj = v;
      this.getData();
    },
    setHight(){
      var h=document.getElementById('mylist').offsetHeight;
      this.height=h;
    }
  },
  mounted() {
    // this.drawBar()
    this.setHight();
  },
};
</script>
<style lang="">
#aedser {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/fenxi/licheng/month.vue